// extracted by mini-css-extract-plugin
module.exports =  {"category":"Category-PXKl__category","dropzone":"Category-KzUd__dropzone","header":"Category-GdQL__header","items":"Category-J0mP__items"};